import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import {history} from '/app/src/store';
import React from 'react'
import AssignedContainer from './AssignedContainer'
import UnassignedContainer from './UnassignedContainer'
import InternContainer from './InternContainer'
import PublicContainer from './PublicContainer'
import {Flex} from '/app/src/component'
//Models
import ConversationModel from '/app/src/model/Conversation/model'


class PreviewContainer extends React.Component {

    constructor(props) {
        super(props);
        this.__handleOnClick = this.__handleOnClick.bind(this);
        this.itemRef = React.createRef();
    }

    __handleOnClick(){
        if(this.props.currentRoom !== this.props.room){
            history.push({pathname: '/conversation/' + this.props.room});
            this.props.dispatch(ConversationModel.setReadToDB(this.props.room));
        }
    }

    render() {
        const room = this.props.room;
        const currentRoom = this.props.currentRoom;
        const type = this.props.type;
        let convoComponent;
        switch(type){
            case 'assigned':
                convoComponent= <AssignedContainer room={room} currentRoom={currentRoom}/>
                break;
            case 'unassigned':
                convoComponent= <UnassignedContainer room={room} currentRoom={currentRoom}/>
                break;
            case 'public':
                convoComponent= <PublicContainer room={room} currentRoom={currentRoom}/>
                break;
            default:
                convoComponent= <InternContainer room={room} currentRoom={currentRoom}/>
                break;
        }

        return (
            <Flex id={''+this.props.location.key} onClick={this.__handleOnClick} width='100%' shrink={0} hostRef={this.itemRef}>
                {convoComponent}
            </Flex>
        )
    }

}
function mapStateToProps(state, ownProps) {
    return {
        currentRoom: ownProps.history.location.pathname.replace('/conversation/', ''),
    };
}

export default withRouter(connect(mapStateToProps)(PreviewContainer))



// WEBPACK FOOTER //
// ./src/component/Conversation/Preview/index.js